const ROOT = 'requirement' as const

export const requirementKeys = {
  all: [ROOT] as const,
  detail: (requirementId?: number) => [ROOT, requirementId] as const,
  fuzzySearch: (params?: { search?: string; limit?: number }) =>
    [...requirementKeys.all, 'fuzzySearch', params] as const,
  positions: (requirementId?: number) =>
    [ROOT, requirementId, 'positions'] as const,
  positionsList: (
    params: {
      requirementId?: number
      pageSize?: number
    } = {}
  ) =>
    [
      ...requirementKeys.positions(params.requirementId),
      { pageSize: params.pageSize },
    ] as const,
}
